import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { AccountingAccountsService } from './accounting-accounts.service';
import { AccountingAccountsListComponent } from './accounting-accounts-list.component';

@Component({
    selector: 'convfact-accountingAccountsDelete',
    templateUrl: './accounting-accounts-dialog-delete.component.html',
    styleUrls: ['./accounting-accounts.component.css'],
    standalone: false
})

export class AccountingAccountsDialogDeleteComponent {

  uid: string = this.data.uid;
  error = false;

  constructor(
    public dialogRef: MatDialogRef<AccountingAccountsListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public accountingAccountsService: AccountingAccountsService
  ) { }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  delete() {
    this.accountingAccountsService.delete(this.uid)
      .then(response => {
        this.displayInfo(response);
        this.closeDialog();
      })
      .catch(error => {
        this.displayInfo(error['message']);
        this.closeDialog();
      });

    this.error = true;
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
